// Libellés des raisons d'abandon du formulaire de commande, partagés par
// l'écran global des abandons et la fiche utilisateur.
const RAISON_LABELS = {
  quitte_page: "A quitté la page",
  erreurs_validation: "Erreurs de validation",
  autre: "Autre",
};

export const getRaisonLabel = (raison) => RAISON_LABELS[raison] || raison || "Non renseignée";

// `erreurs_validation` est le JSON des erreurs du formulaire ({champ: message}).
// Renvoie les messages, ou [] si absent ou illisible.
export const messagesErreurs = (erreurs) => {
  if (!erreurs) return [];
  try {
    const objet = typeof erreurs === "string" ? JSON.parse(erreurs) : erreurs;
    const aplatir = (v) => (v && typeof v === "object" ? Object.values(v).flatMap(aplatir) : [String(v)]);
    return aplatir(objet).filter(Boolean);
  } catch {
    return [String(erreurs)];
  }
};
